import { Fragment } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Button, InteractiveTable } from '@ingrid/luterkort-react';

import { DetailsDrawer as Drawer } from '~src/components/DetailsDrawer/DetailsDrawer';
import { RoleGuard } from '~src/components/RoleGuard/RoleGuard';
import { useTranslation } from '~src/i18n/use-translation';
import { AppRoute } from '~src/main/routes';

import { Menu } from '../menu';
import { CarrierContractDetail } from '../queries';

interface Props {
  contract?: CarrierContractDetail;
}

function CarrierContractDrawerAction({ contract }: Props) {
  const { setHighlightedKey } = InteractiveTable.useContext();
  const { t } = useTranslation();

  if (!contract) {
    return false;
  }

  return (
    <Fragment>
      <RoleGuard roles={['transport:edit']} withTooltip>
        <Button as={RouterLink} to={`${AppRoute.EDIT}/${contract.contract_id}`}>
          {t('common.edit')}
        </Button>
      </RoleGuard>

      <Menu>
        <Menu.DuplicateItem contractId={contract.contract_id!} />
        <Menu.DeleteItem contractId={contract.contract_id!} onSuccess={() => setHighlightedKey(null)} />
      </Menu>
    </Fragment>
  );
}

export function DetailsDrawer({ contract }: Props) {
  return (
    <Drawer
      actions={<CarrierContractDrawerAction contract={contract} />}
      detailsHref={contract?.contract_id}
      nodes={[
        <Drawer.Plain
          label="carrierContracts.details.field.common.contract_id"
          value={contract?.contract_id}
          key="id"
        />,
        <Drawer.Plain label="common.name" value={contract?.name} key="name" />,
        <Drawer.Plain label="common.description" value={contract?.description} key="description" />,
        <Drawer.Carrier label="common.carrier" value={contract?.carrier_products?.[0].shipping_method} key="carrier" />,
        <Drawer.Date label="common.createdAt" value={contract?.created_at} time key="created" />,
        <Drawer.Date label="common.updatedAt" value={contract?.updated_at} time key="updated" />,
      ]}
    />
  );
}
